var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warpper"},[(_vm.ifShow && _vm.sendMessage.length > 0)?_c('tip',{attrs:{"status":_vm.sendStatus,"message":_vm.sendMessage}}):_vm._e(),_vm._v(" "),_c('Loading',{attrs:{"stop":_vm.loadingShow}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1820ca7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Implicit.vue
// module id = null
// module chunks = 